export const AppointmentWidgetId = 'AppointmentWidget';

export enum AppointmentWidgetAttributes {
  LABEL = 'label',
  LINK = 'link',
}
